import { riskGradePalette } from '@innovyze/stylovyze';
import { CheckCircle } from '@mui/icons-material';
import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';

interface ConditionCellProps {
	condition: string;
	/** Redesign: render a muted dash for "not inspected" instead of a blank. */
	showNotInspected?: boolean;
}

export const ConditionCell = ({
	condition,
	showNotInspected = false,
}: ConditionCellProps) => {
	const { t } = useGlobalization();
	if (condition === '1' || condition === 'true') {
		return (
			<CheckCircle
				style={{
					color: riskGradePalette.low.dark,
					verticalAlign: 'middle',
				}}
			/>
		);
	}
	if (showNotInspected) {
		return (
			<span
				data-cy="condition-not-inspected"
				role="img"
				aria-label={t('Not inspected')}
				style={{ color: '#6b7280' }}>
				—
			</span>
		);
	}
	return <></>;
};
